import { createStore, applyMiddleware } from 'redux'
import rootReducer from './reducer/rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

const composeMiddleware = composeWithDevTools(applyMiddleware(thunkMiddleware))
const store = createStore(rootReducer, composeMiddleware)

export default store